import { graphql, PageProps } from 'gatsby'
import React from 'react'
import RehypeReact from 'rehype-react'
import Footer from '../../components/organisms/footer'
import GoogleAnalytics from '../../components/organisms/google-analytics'
import Header from '../../components/organisms/header'
import PageSatisfactionSurvey from '../../components/organisms/page-satisfaction-survey'
import SEO from '../../components/organisms/seo'
import { useWindowSize } from '../../hooks/use-window-size'

const ContentPost: React.FC<PageProps<Queries.Query>> = ({ data }) => {
  const { width, height } = useWindowSize()
  const iframeHeight =
    width && height ? height - (width > 1024 ? 200 : 100) : '0'
  const renderAst = new RehypeReact({
    createElement: React.createElement,
    components: {
      iframe: (props) => {
        return <iframe {...props} width='100%' height={iframeHeight} />
      },
    },
  }).Compiler

  const title = `${data.markdownRemark?.frontmatter?.title} | RICOH 4K Live Streaming`
  const pathname = `/docs/${String(
    data.markdownRemark?.fields?.slug?.replace(/\/$/, '').split('/').pop(),
  )}`

  return (
    <>
      <SEO
        title={title}
        description={data.markdownRemark?.frontmatter?.description || ''}
        pathname={pathname}
        type='article'
      />
      <GoogleAnalytics />
      <Header />
      <div className='flex'>
        <div className='w-full'>
          <div className='mx-auto px-4 pb-10 lg:p-8'>
            {renderAst(data.markdownRemark?.htmlAst)}
            <div className='my-10'>
              <PageSatisfactionSurvey viewedPage={pathname} />
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </>
  )
}

export default ContentPost

export const query = graphql`
  query RedocPage($id: String!, $language: String!) {
    markdownRemark(id: { eq: $id }) {
      headings {
        id
        value
        depth
      }
      frontmatter {
        title
        description
        category
      }
      fields {
        slug
      }
      htmlAst
    }
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`
